<template>
  <div class="container">
    <div class="contentFont">
      <p class="title">{{data.title}}</p>
      <p class="time">{{data.startTime}}</p>
      <div class="content1" v-html="data.content">{{ data.content }}</div>
    </div>
  </div>
</template>

<script>
  import util from '../../utils/util';
  import {
    djSelectById,
  } from '@/apis/new/new';
  import mobileType from '../../utils/mobileType';

  export default {
    data() {
      return {
        data: {}
      };
    },
    created() {
      //Vue的方法给原生调用，则需要把方法挂在Window下面
      window.getDataFromNative = this.getDataFromNative;
    },
    mounted() {
    //   this.getInfo()
      this.getUserInfoFromApp();
    },
    filters: {
      formatDate(val) {
        return util.timestampToTime(val);
      }
    },
    methods: {
      getUserInfoFromApp() {
        let params = {
          methodName: 'getDataFromNative',//定义与原生的方法名(固定)
          type: 1,//业务类型(固定)
        };
        if (mobileType.isIOS()) {
          //vue调用iOS方法，且传值给iOS （iOS 方法名为 getDataFromVue）
          window.webkit.messageHandlers.getDataFromVue.postMessage(params);
        } else if (mobileType.isAndroid()) {
          //vue调用Android方法，且传值给Android （Android方法名为 getDataFromVue）
          window.Android.getDataFromVue(JSON.stringify(params));
        } else {
        }
      },
      getDataFromNative(params) {
        if (mobileType.isIOS()) {
          this.params = params;
        } else if (mobileType.isAndroid()) {
          this.params = JSON.parse(params);
        }
        this.getInfo();
      },
      // 获取数据
      async getInfo() {
        // let params = {
        //   channel: '1020000000',
        //   platform: '3',
        //   softVersion: '4.7.8',
        //   sysVersion: 'TNY-AL00,10',
        //   data: {
        //     id: 135
        //   },
        //   token: 'MTAxNzAwNDAzOjcwMDoyMDIzMDMxNDE2MDMyMDQwOTpmZmZmZmZmZi04OThmLTVhOGEtZmZmZi1mZmZmZWYwNWFjNGE\u003d',
        // };
        let params = {
          channel: this.params.channel,
          deviceId: this.params.deviceId,
          platform: this.params.platform,
          softVersion: this.params.softVersion,
          sysVersion: this.params.sysVersion,
          data: {
            id: this.$route.query.id
          },
          token: this.params.token,
        };
        params.data = JSON.stringify(params.data);
        try {
          const data = await djSelectById(params);
          if (data.code == 1 && data.data) {
            this.data = JSON.parse(data.data);
          }
        } catch (error) {
        }
      }
    },
  };
</script>
<style lang="less">
.content1 {
    img {
      height: auto !important;
      max-width: 100% !important ;
    }
    p {
      font-size: 14px !important;
      font-weight: 400 !important;
      color: #333333 !important;
      line-height: 20px !important;
    }
  }
</style>
<style scoped lang="less">
  .contentFont {
    padding: 1rem 1.25rem 1rem 1.25rem;
  }
  .title {
    font-size: 22px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 30px;
    margin-top:20px;
  }
  .time {
    margin:10px 0px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 18px;
  }
</style>

